import { FILTER_KEYS, HAS_VALUES, memberInfo } from './chatSearchQuery';
import { dayToken } from './chatSearchParams';

/**
 * The autocomplete rows for a context from `autocompleteContext` (pure, so the
 * search bar's keyboard handling and the menu render the same list).
 *
 * Row: { id, kind: 'key' | 'has' | 'member' | 'date' | 'pick', token, ... }
 * `token` is what replaces the context's range; 'pick' (the date picker row)
 * has none — it inserts whatever day the picker emits.
 */
const quoteIfNeeded = (v) => (/\s/.test(v) ? `"${v}"` : v);

export function buildSuggestions(ctx, members, now = new Date()) {
  if (!ctx) return [];
  const partial = (ctx.partial || '').toLowerCase();
  if (ctx.mode === 'keys') {
    return FILTER_KEYS.filter((k) => k.startsWith(partial)).map((key) => ({
      id: `key:${key}`,
      kind: 'key',
      key,
      token: `${key}:`,
    }));
  }
  if (ctx.mode === 'has') {
    return HAS_VALUES.filter((h) => h.value.startsWith(partial)).map((h) => ({
      id: `has:${h.value}`,
      kind: 'has',
      value: h.value,
      icon: h.icon,
      labelKey: h.labelKey,
      token: `has:${h.value}`,
    }));
  }
  if (ctx.mode === 'from') {
    const seen = new Set();
    return (members || [])
      .map(memberInfo)
      .filter((m) => m.id != null && m.name && !seen.has(m.id) && seen.add(m.id))
      .filter((m) => !partial || m.name.toLowerCase().includes(partial) || m.email.toLowerCase().includes(partial))
      .map((m) => ({ id: `from:${m.id}`, kind: 'member', member: m, token: `from:${quoteIfNeeded(m.name)}` }));
  }
  if (ctx.mode === 'date') {
    const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
    return [
      { id: 'date:today', kind: 'date', labelKey: 'chat.search.date.today', token: `${ctx.key}:${dayToken(now)}` },
      { id: 'date:yesterday', kind: 'date', labelKey: 'chat.search.date.yesterday', token: `${ctx.key}:${dayToken(yesterday)}` },
      { id: 'date:pick', kind: 'pick', labelKey: 'chat.search.date.pick', token: null },
    ];
  }
  return [];
}
